export default "__VITE_ASSET__Dn5zyLP7__"